import React from 'react'
import styles from './index.module.scss'
import { FormattedMessage } from 'react-intl'
import { useIntl } from 'react-intl'
import useFormatIntlString from '../../../hooks/useFormatIntlString'

import Form from 'react-bootstrap/Form'

const FormField = ({labelText, index, inputValue, onChange, inputEditable, isInvalid}) => {

  const formatIntlString = useFormatIntlString();
  const intl = useIntl();

  return (
    <tr>
      <FormattedMessage id='formBoxStep' defaultMessage="Step">{(msg) => (<td data-label={msg}><Form.Label htmlFor={`formFieldInput_${index}`} className={styles.labelText}>{labelText}</Form.Label></td>)}</FormattedMessage>

      <FormattedMessage id='formBoxDate' defaultMessage="Date">{(msg) => (<td data-label={msg} className={styles.FormBoxDate}>
        <Form.Control
          type="date" 
          onChange={(event) => onChange(event.target.value)} value={inputValue || ''}
          disabled={!inputEditable}
          name={`formFieldInput_${index}`}
          id={`formFieldInput_${index}`}
          isInvalid={isInvalid.status}
        />
        {
          isInvalid.nextLabelText && isInvalid.previousLabelText ? (
            <Form.Control.Feedback type="invalid" tooltip className={styles.InvalidTooltip}>{formatIntlString(intl.messages.invalidBothFieldsValueError, [isInvalid.nextLabelText, isInvalid.previousLabelText, labelText])}</Form.Control.Feedback>
          ) : isInvalid.nextLabelText ? (
            <Form.Control.Feedback type="invalid" tooltip className={styles.InvalidTooltip}>{formatIntlString(intl.messages.invalidNextFieldValueError, [isInvalid.nextLabelText, labelText])}</Form.Control.Feedback>
          ) : (
            <Form.Control.Feedback type="invalid" tooltip className={styles.InvalidTooltip}>{formatIntlString(intl.messages.invalidPreviousFieldValueError, [isInvalid.previousLabelText, labelText])}</Form.Control.Feedback>
          )
        }
      </td>)}</FormattedMessage>
    </tr>
  )
}

export default FormField